import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const subadminService = {
  getAdminInfo: (userId) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.adminInfo}/${userId}`),
  getSubadminList: () =>
    axiosInstance.get(endpoints.tokenEndPoints.getSubadminList),
  deleteSubadmin: (id) =>
    axiosInstance.delete(`${endpoints.tokenEndPoints.deleteSubadmin}/${id}`),
  getSubadmin: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.detailsSubadmin}/${id}`),
  updateSubadmin: (id, data) =>
    axiosInstance.patch(`${endpoints.tokenEndPoints.updateSubadmin}/${id}`, data),
  createSubadmin: (data) =>
    axiosInstance.post(endpoints.tokenEndPoints.addSubadmin, data),
  getSubadminPermission: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.subadminPermission}/${id}`),
};
